import {classNames, layout} from "@variocube/cube-ui";
import * as React from "react";
import {useEffect, useState} from "react";
import {stylesheet} from "typestyle";
import {Tool} from "./Tool";
import {MockToolProps} from "./types";

export function DoorbellTool({mockController, align}: MockToolProps) {
	const [lastRang, setLastRang] = useState("");
	const [highlight, setHighlight] = useState(false);

	useEffect(() => {
		const listener = (serialNumber: string) => {
			setLastRang(serialNumber);
			setHighlight(true);
		};
		mockController.doorbell.ringEvent.add(listener);
		return () => mockController.doorbell.ringEvent.remove(listener);
	}, []);

	useEffect(() => {
		const timeout = setTimeout(() => setHighlight(false), 10000);
		return () => clearTimeout(timeout);
	}, [highlight, lastRang]);

	return (
		<Tool label="Doorbell" highlight={highlight} align={align}>
			<div className={classNames(layout.paddingSmall)}>
				<p>Last rang doorbell:</p>
				<div className={styles.lastRang}>
					{lastRang || "(none)"}
				</div>
			</div>
		</Tool>
	);
}

const styles = stylesheet({
	lastRang: {
		fontSize: "3rem",
	},
});
